import type { LegalAidEvidenceModel } from "@/api/cle-api";
import { formatLegalAidCategory } from "@/api/cle-api/models/legalAid";
import { UserQueryContext } from "@/context/UserContext";
import { formatLessons } from "@/util/number";
import { useContext } from "react";

import { DetailItem } from "../person/id/Efteruddannelse/DetailItem";
import { LegalAidEditModal } from "./LegalAidEditModal";

interface LegalAidInformationProps {
  legalAid: LegalAidEvidenceModel;
  onLegalAidUpdated?: (updated: LegalAidEvidenceModel) => void;
}

export const LegalAidInformation = ({
  legalAid,
  onLegalAidUpdated,
}: LegalAidInformationProps) => {
  const { user, hasPermission } = useContext(UserQueryContext);
  // Reported (indberettet) evidence backs a signed declaration and is immutable;
  // the API refuses these edits with 409 EVIDENCE_ALREADY_REPORTED.
  const canEdit = hasPermission(user, "TilsynWrite") && !legalAid.isReported;

  const handleSave = (updated: LegalAidEvidenceModel) => {
    onLegalAidUpdated?.(updated);
  };

  return (
    <div className="c-card c-item-list ">
      <div className="flex-100 d-flex justify-content-between flex-row align-items-center">
        <h3 className="mb-0">Advokatvagt/retshjælp-oplysninger</h3>
        {canEdit && (
          <LegalAidEditModal legalAid={legalAid} onSave={handleSave} />
        )}
      </div>
      <div className="d-flex flex-column gap-2">
        <DetailItem
          label="Type"
          value={formatLegalAidCategory(legalAid.category)}
        />
        <DetailItem
          label="Antal lektioner"
          value={formatLessons(legalAid.numberOfLessons)}
        />
      </div>
    </div>
  );
};
